/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-explicit-any */
import IconAngleBottom from '@assets/icons/angle-bottom.svg?react';
import {
 Accordion,
 AccordionDetails,
 AccordionSummary,
 Box,
 Checkbox,
 FormControlLabel,
 FormGroup,
 Theme,
 Typography,
 useTheme,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { usePage } from '../../../contexts/usePageContext';
import { useCurrentStructure } from '../../../hooks/useCurrentStructure';
import {
 changeCurrentPreset,
 ColPresetType,
} from '../../../redux/clientConfiguration/clientConfigurationSlice';
import { useAppDispatch } from '../../../redux/hooks';
import { RootState } from '../../../redux/store';
import { StructureType } from '../../../types/types';
import customColors from '../../../utils/customColors';
import { findNormalizedMatchRange } from '../../../utils/stringUtils';
import SearchCol from '../FieldSearch';
import {
 filterStructureForExpanded,
 filterStructureForSearch,
 isSelected,
 sortStructure,
} from './utils';

interface ExpandedStateType {
 [key: string]: boolean;
}

const highlightText = (text: string, highlight: string, theme: Theme) => {
 const matchRange = findNormalizedMatchRange(text || '', highlight || '');
 if (!matchRange) {
  return (
   <span
    style={{
     width: '100%',
     display: 'block',
    }}
   >
    {text}
   </span>
  );
 }
 const start = text.slice(0, matchRange.start);
 const match = text.slice(matchRange.start, matchRange.end);
 const end = text.slice(matchRange.end);
 return (
  <span
   style={{
    width: '100%',
    display: 'block',
    // textOverflow: 'ellipsis',
    // overflow: 'hidden',
   }}
  >
   {start}
   <span
    style={{
     backgroundColor: customColors.yellow,
     color: 'inherit',
    }}
   >
    {match}
   </span>
   {end}
  </span>
 );
};

// const hasSelectedKey = (
//  data: StructureType[],
//  prefix: string,
//  tempColumnsPreset: ColPresetType | null,
// ) => {
//  for (const i of data) {
//   const fullKey = prefix ? `${prefix}.${i.Name}` : i.Name;

//   if (isSelected(fullKey, tempColumnsPreset)) {
//    return true;
//   }

//   if (Array.isArray(i.InnerStructure) && i.InnerStructure.length > 0) {
//    if (hasSelectedKey(i.InnerStructure, fullKey, tempColumnsPreset)) {
//     return true;
//    }
//   }
//  }

//  return false;
// };

const RenderModalCols = ({
 item,
 pName,
 depth,
 searchValue,
 tempColumnsPreset,
 handleSetPreset,
 expandedState,
 setExpandedState,
 theme,
}: {
 item: StructureType;
 pName: string;
 depth: number;
 searchValue: string;
 tempColumnsPreset: ColPresetType | null;
 handleSetPreset: (data: any) => void;
 expandedState: ExpandedStateType;
 setExpandedState: (
  value:
   | ExpandedStateType
   | ((prevState: ExpandedStateType) => ExpandedStateType),
 ) => void;
 theme: Theme;
}) => {
 depth++;
 const currentPath = pName || item.Name;

 if (['model', 'array'].includes(item.Type)) {
  return (
   <Box key={item.Name} sx={{ p: 0, width: '100%' }}>
    <Accordion
     sx={{
      borderRadius: '0 !important',
      boxShadow: 'none',
     }}
     expanded={expandedState?.[`${depth}_${item.Name}`] || false}
     onChange={() => {
      setExpandedState((prevState: ExpandedStateType) => ({
       ...prevState,
       [`${depth}_${item.Name}`]: !prevState[`${depth}_${item.Name}`] || false,
      }));
     }}
    >
     <AccordionSummary
      sx={{
       minHeight: '40px',
       borderBottom: (themeParam: Theme) =>
        `1px solid ${themeParam.palette.kemek.lightestGray}`,
       '&.Mui-expanded': { minHeight: '32px' },
       '& .MuiAccordionSummary-content': {
        margin: 0,
        alignItems: 'center',
        '&.Mui-expanded': { margin: 0 },
       },
       //  p: 0,
       pl: depth > 1 ? depth * 0.5 : 0,

       '.MuiButtonBase-root.MuiCheckbox-root': { p: '6px' },
      }}
      expandIcon={<IconAngleBottom />}
      aria-controls={`${item.Name}-content`}
      id={`${item.Name}-header`}
     >
      <Checkbox
       checked={isSelected(currentPath, tempColumnsPreset)}
       onChange={() =>
        handleSetPreset(
         isSelected(currentPath, tempColumnsPreset)
          ? tempColumnsPreset?.columns.filter((x) => x.field !== currentPath)
          : [...(tempColumnsPreset?.columns || []), { field: currentPath }],
        )
       }
       onClick={(e) => e.stopPropagation()} // Prevent accordion from closing
       sx={{ ml: 1 }}
      />
      <Typography
       sx={{ fontWeight: 500, textOverflow: 'ellipsis', overflow: 'hidden' }}
      >
       {highlightText(item.Translation, searchValue, theme)}
      </Typography>
     </AccordionSummary>
     <AccordionDetails sx={{ p: 0, pl: 1 }}>
      <FormGroup
       sx={{
        pl: 0,
        borderBottom: (themeParam: Theme) =>
         `1px solid ${themeParam.palette.kemek.lightestGray}`,
        width: '100%',
       }}
      >
       {item.InnerStructure.map((value: StructureType) => {
        const row = item.InnerStructure.find((o) => o.Name === value.Name);
        if (!row) return null;
        const innerName = row.Name;
        if (['model', 'array'].includes(row.Type)) {
         return RenderModalCols({
          item: row,
          pName: `${currentPath}.${innerName}`,
          depth,
          searchValue,
          tempColumnsPreset,
          handleSetPreset,
          expandedState,
          setExpandedState,
          theme,
         });
        }
        return (
         <FormControlLabel
          sx={{
           pl: depth === 0 ? 0 : depth * 2,
           //  ml: 1,
           //  textOverflow: 'ellipsis',
           //  overflow: 'hidden',
           width: '100%',
           display: 'inline-flex',
           '.MuiButtonBase-root.MuiCheckbox-root': { p: '6px' },
          }}
          label={highlightText(row.Translation, searchValue, theme)}
          key={`all_${item.Name}.${innerName}`}
          control={
           <Checkbox
            checked={isSelected(
             `${currentPath}.${innerName}`,
             tempColumnsPreset,
            )}
            onChange={() =>
             handleSetPreset(
              isSelected(`${currentPath}.${innerName}`, tempColumnsPreset)
               ? tempColumnsPreset?.columns.filter(
                  (x) => x.field !== `${currentPath}.${innerName}`,
                 )
               : [
                  ...(tempColumnsPreset?.columns || []),
                  { field: `${currentPath}.${innerName}` },
                 ],
             )
            }
           />
          }
         />
        );
       })}
      </FormGroup>
     </AccordionDetails>
    </Accordion>
   </Box>
  );
 }
 return (
  <Box key={item.Name} sx={{ px: 1 }}>
   <FormGroup>
    <FormControlLabel
     sx={{
      m: 0,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: '100%',
      display: 'inline-flex',
      '.MuiButtonBase-root.MuiCheckbox-root': { p: '6px' },
     }}
     control={
      <Checkbox
       checked={isSelected(item.Name, tempColumnsPreset)}
       onChange={() =>
        handleSetPreset(
         isSelected(item.Name, tempColumnsPreset)
          ? tempColumnsPreset?.columns.filter((x) => x.field !== item.Name)
          : [...(tempColumnsPreset?.columns || []), { field: item.Name }],
        )
       }
      />
     }
     label={highlightText(item.Translation, searchValue, theme)}
    />
   </FormGroup>
  </Box>
 );
};

const ColModalCols = () => {
 const dispatch = useAppDispatch();
 const { t } = useTranslation();
 const theme = useTheme();
 const { pageName } = usePage();
 const structure = useCurrentStructure();
 const [searchValue, setSearchValue] = useState('');
 const [expandedState, setExpandedState] = useState<ExpandedStateType>({});

 const tempColumnsPreset = useSelector(
  (state: RootState) =>
   state.clientConfiguration.tempColumnsPreset?.[pageName] || null,
 );

 const handleSetPreset = (columns: GridColDef[]) => {
  dispatch(
   changeCurrentPreset({
    page: pageName,
    type: 'columns',
    preset: {
     ...tempColumnsPreset,
     name: tempColumnsPreset?.name || 'Custom',
     columns,
    },
    temp: true,
   }),
  );
 };

 const filteredStructure = useMemo(
  () => filterStructureForSearch(structure, searchValue),
  [structure, searchValue],
 );

 useEffect(() => {
  if (searchValue) {
   if (filteredStructure.length > 0) {
    const modelOrArrayNames = filterStructureForExpanded(filteredStructure);
    setExpandedState(
     modelOrArrayNames.reduce((acc, item) => {
      acc[item] = true;
      return acc;
     }, {} as ExpandedStateType),
    );
   }
  } else {
   // Collapse all accordions when search is cleared
   setExpandedState({});
  }
 }, [filteredStructure, searchValue]);

 const structureSorted = useMemo(
  () => sortStructure(filteredStructure),
  [filteredStructure],
 );

 const Sorted = structureSorted.map((item) =>
  RenderModalCols({
   item,
   pName: '',
   depth: 0,
   searchValue,
   tempColumnsPreset,
   handleSetPreset,
   expandedState,
   setExpandedState,
   theme,
  }),
 );

 return (
  <Box
   sx={{
    borderRadius: '4px',
    border: (themeParam: Theme) =>
     `1px solid ${themeParam.palette.kemek.lightestGray}`,
    borderBottom: 0,
    width: { xs: '100%', md: 280 },
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
   }}
  >
   <Box sx={{ flexShrink: 0 }}>
    <SearchCol
     searchValue={searchValue}
     setSearchValue={setSearchValue}
     label={t('colModal.colsAll')}
    />
   </Box>
   <Box
    sx={{
     flex: 1,
     minHeight: 0,
     overflowY: 'auto',
     width:
      searchValue.trim() !== '' ||
      Object.values(expandedState).some((expanded) => expanded)
       ? '100%'
       : '100%',
    }}
   >
    {Sorted}
   </Box>
  </Box>
 );
};
export default ColModalCols;
